<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03"></a><a id="page_iii"></a><strong>Daddy Grace</strong></h1>
<p class="bsubtitleleft1"><strong><em>A Celebrity Preacher and His House of Prayer</em></strong></p>
<p class="authorleft">Marie W. Dallam</p>
<p class="images1"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?1fccc40b